import { render, staticRenderFns } from "./Enrollment.vue?vue&type=template&id=be4bd022&scoped=true&"
import script from "./Enrollment.vue?vue&type=script&lang=js&"
export * from "./Enrollment.vue?vue&type=script&lang=js&"
import style0 from "./Enrollment.vue?vue&type=style&index=0&id=be4bd022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4bd022",
  null
  
)

export default component.exports